import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';

const DemoRedirect = ({ children, featureName }) => {
  const { id } = useParams();
  const userRole = localStorage.getItem('userRole');
  const isDemo = userRole === 'demo';

  if (isDemo) {
    return <Navigate to={`/coming-soon?feature=${encodeURIComponent(featureName)}`} replace />;
  }

  return children;
};

export default DemoRedirect;

